"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAnonymousSessionContext = setAnonymousSessionContext;
const AAPITypes_1 = require("../AAPITypes");
const Utils_1 = require("../../../Shared/Utils/Utils");
const CommonEnums_1 = require("../../../Shared/Enums/CommonEnums");
function setAnonymousSessionContext(params) {
    const correlationData = this.addToCorrelation(params);
    if (this.initializationParams.useJSON) {
        const request = {
            aapiId: AAPITypes_1.aapiId.setAnonymousSessionContext,
            correlationId: correlationData.correlationDataId,
            cohort: params.cohort,
            state: '',
            zipCode: '',
            integrationPartnerId: params.integrationPartnerId,
            aAPIVersion: this._version.aapiVersion,
            clientSpecifiedGuid: params.clientSpecifiedGuid || Utils_1.GBETUtils.createUUID(),
            granularChannelType: params.granularChannelType,
            channelInformation: params.channelInformation,
            clientIdentifier: params.clientIdentifier?.replace('{gecversion}', this._version.implementationVersion),
            wageringCohort: params.wageringCohort,
        };
        this._sendStreamingMessageJSON(request);
    }
    else {
        const request = {
            0: correlationData.correlationDataId,
            1: params.currency,
            2: params.language,
            3: params.priceFormat,
            4: false,
            6: this._version.aapiVersion,
            7: Utils_1.GBETUtils.createUUID(),
            8: CommonEnums_1.GBET.GranularChannelType.InternetBrowser,
            9: params.channelInformation || '',
        };
        if (params.clientIdentifier !== undefined) {
            request[10] = params.clientIdentifier.replace('{gecversion}', this._version.implementationVersion);
        }
        request[5] =
            params.integrationPartnerId !== undefined
                ? params.integrationPartnerId
                : 7;
        this._sendStreamingMessage(AAPITypes_1.aapiId.setAnonymousSessionContext, request);
    }
    return correlationData.promise;
}
